import { useGetDataSelectAgencyTabQuery } from "@saleor/graphql";
import { mapNodeToChoiceWithCode } from "@saleor/utils/maps";
import { useMemo } from "react";

const useAgency = salesOrganizationsCode => {
  const { data: dataAgencyTab } = useGetDataSelectAgencyTabQuery({
    displayLoader: true,
    variables: {
      saleOrg: salesOrganizationsCode
    },
    skip: !salesOrganizationsCode
  });

  const saleOrganizationChoices = useMemo(
    () => mapNodeToChoiceWithCode(dataAgencyTab?.salesOrganizations),
    [dataAgencyTab]
  );

  const distributionChannelChoices = useMemo(
    () => mapNodeToChoiceWithCode(dataAgencyTab?.distributionChannelsExport),
    [dataAgencyTab]
  );

  const saleOfficeChoices = useMemo(
    () => mapNodeToChoiceWithCode(dataAgencyTab?.salesOffices),
    [dataAgencyTab]
  );

  const saleGroupChoices = useMemo(
    () => mapNodeToChoiceWithCode(dataAgencyTab?.salesGroups),
    [dataAgencyTab]
  );

  const divisionChoices = useMemo(
    () => mapNodeToChoiceWithCode(dataAgencyTab?.scgDivisions),
    [dataAgencyTab]
  );

  return [
    saleGroupChoices,
    divisionChoices,
    saleOfficeChoices,
    distributionChannelChoices,
    saleOrganizationChoices
  ];
};

export default useAgency;
